import { BadgeNumber } from './BadgeNumber.component';

export { BadgeNumber };
